<template>
  <div :class="bem.b()">
    <!-- 内容区 -->
    <div :class="bem.e('container')">
      <div :class="bem.e('left-info')">
        <!-- 标题行 -->
        <div :class="bem.e('title-content')">
          <!-- 左侧图标 -->
          <ll-icon
            v-if="iconName"
            :icon-name="iconName"
            :size="iconSize"
            :color="iconColor"
            :class="bem.m('icon')"
            :style="{ 'margin-right': iconSpace + 'px' }"
          />

          <!-- 动态标题级别 -->
          <div
            :class="[bem.m('title'), bem.is(titleLevel)]"
            :style="titleLevel === 'custom' ? customStyle : ''"
          >
            {{ groupTitle }}
          </div>

          <!-- 问号提示 -->
          <div :class="bem.m('tooltip')" :style="{ fontSize: tipSize + 'px' }">
            <ll-tooltip
              v-if="tip"
              :title="tip"
              placement="top"
              :is-white-bg="isWhiteBg"
            />
          </div>

          <!-- 标签 -->
          <slot v-if="tagSlot" name="tag"></slot>
        </div>

        <!-- 描述文本 -->
        <ll-html
          v-if="description"
          :class="bem.e('description')"
          :value="description"
        />
      </div>
      <!-- 操作区 -->
      <div v-if="rightOperateSlot" :class="bem.e('right-operate')">
        <slot name="right-operate"></slot>
      </div>
    </div>

    <!-- 分割线 -->
    <ll-divider
      v-if="showDivider"
      :class="bem.e('divider')"
      :border-color="dividerColor"
      :style="{ 'margin-top': dividerSpace + 'px', 'margin-bottom': '0' }"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { groupTitleProps } from './group-title'

// 1.defineOptions
defineOptions({
  name: 'LlGroupTitle',
})
// 定义组件props
const props = defineProps(groupTitleProps)

const bem = createNamespace('group-title')

// 自定义标题样式
const customStyle = computed(() => ({
  fontSize: props.titleFontSize,
  fontWeight: props.titleWeight,
  lineHeight: props.titleLineHeight,
  color: props.titleColor,
}))
</script>
